import Vue from 'vue'
import Vuex from 'vuex'
import theme from './theme'
import additionalCosts from './additional-costs'
import addresses from './addresses'
import campaigns from './campaigns'
import companies from './companies'
import countries from './countries'
import fields from './fields'
import files from './files'
import forms from './forms'
import hashlinks from './hashlinks'
import jobs from './jobs'
import mails from './mails'
import offers from './offers'
import orderConfirmationRequests from './order-confirmation-requests'
import orderConfirmations from './order-confirmations'
import pdfs from './pdfs'
import persons from './persons'
import prices from './prices'
import productFiles from './product-files'
import productTypes from './product-types'
import products from './products'
import productTemplates from './product-templates'
import proofs from './proofs'
import ratings from './ratings'
import shippingAddresses from './shipping-addresses'
import specimenCopies from './specimen-copies'
import states from './states'
import uploads from './uploads'
import users from './users'
import variants from './variants'
import settings from './settings'

// Vuex registrieren
Vue.use(Vuex)

const state = {}

export default new Vuex.Store({
    strict: true,
    state,
    modules: {
        theme,
        additionalCosts,
        addresses,
        campaigns,
        companies,
        countries,
        fields,
        files,
        forms,
        hashlinks,
        jobs,
        offers,
        orderConfirmationRequests,
        orderConfirmations,
        mails,
        pdfs,
        persons,
        prices,
        productFiles,
        productTypes,
        products,
        productTemplates,
        proofs,
        ratings,
        shippingAddresses,
        specimenCopies,
        states,
        uploads,
        users,
        variants,
        settings
    }
})
